import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinnerThird} from "@fortawesome/pro-light-svg-icons";
import React from "react";
import classNames from "../../utils/class-names.ts";

interface SimpleLoadingIndicatorProps extends React.HTMLAttributes<HTMLDivElement>{
    text?: string;
    orientation?: 'horizontal' | 'vertical'
}

const SimpleLoadingIndicator: React.FunctionComponent<SimpleLoadingIndicatorProps> = ({text, orientation = 'horizontal', ...props}) => (
    <div className={classNames('h-full w-full flex', props.className ?? '')}>
        <div className={`mx-auto my-auto flex items-center gap-4 max-w-full ${orientation === 'vertical' ? 'flex-col' : 'flex-row'}`}>
            <FontAwesomeIcon icon={faSpinnerThird} spin={true} className='shrink-0' />
            <span className='min-w-0 whitespace-normal wrap-break-word'>
                {text ?? 'Chargement'}
            </span>
        </div>
    </div>
)

export default SimpleLoadingIndicator;